import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Form,
    Button,
    Table,
    Badge,
    InputGroup,
} from "react-bootstrap";
import img from "../../assets/img123.png";


const requestHistory = [
    {
        id: 1,
        userId: "USR1021",
        amount: "$250",
        txn: "TXN458712",
        date: "02 Jun 2026",
        status: "Pending",
    },
    {
        id: 2,
        userId: "USR1022",
        amount: "$500",
        txn: "TXN998145",
        date: "01 Jun 2026",
        status: "Approved",
    },
    {
        id: 3,
        userId: "USR1023",
        amount: "$150",
        txn: "TXN887412",
        date: "30 May 2026",
        status: "Rejected",
    },
    {
        id: 4,
        userId: "USR1024",
        amount: "$350",
        txn: "TXN114589",
        date: "29 May 2026",
        status: "Approved",
    },
];

export default function UserFundRequest() {
    return (
        <>
            <div className="fund-page-wrapper">

                <Container fluid>



                    <Card className="fund-top-card">

                        <div className="fund-header">

                            <div>

                                <h2 className="fund-title">
                                    Member Fund Request
                                </h2>

                                <p className="fund-subtitle">
                                    Submit your payment receipt and request funds securely
                                </p>

                            </div>

                            <Badge className="fund-badge">
                                Secure Payment
                            </Badge>

                        </div>

                        <Row className="g-4 align-items-center">



                            <Col lg={5}>

                                <div className="fund-left-box">

                                    <div className="payment-image-box">

                                        <img
                                            src={img}
                                            alt="payment"
                                            className="payment-img"
                                        />

                                    </div>

                                    <Button className="whatsapp-btn">

                                        <i className="bi bi-whatsapp"></i>

                                        Send on WhatsApp

                                    </Button>

                                </div>

                            </Col>



                            <Col lg={7}>

                                <div className="upi-card">

                                    <label className="upi-label">
                                        UPI ID
                                    </label>

                                    <InputGroup>

                                        <Form.Control
                                            value="8545@ybl"
                                            readOnly
                                            className="fund-input"
                                        />

                                        <Button className="copy-btn">

                                            <i className="bi bi-copy"></i>

                                            Copy

                                        </Button>

                                    </InputGroup>

                                </div>

                                <Form className="fund-form">

                                    <Form.Group className="mb-3">

                                        <Form.Label>
                                            Upload Receipt
                                        </Form.Label>

                                        <Form.Control
                                            type="file"
                                            className="fund-input"
                                        />

                                    </Form.Group>

                                    <Form.Group className="mb-3">

                                        <Form.Label>
                                            Amount
                                        </Form.Label>

                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Amount"
                                            className="fund-input"
                                        />

                                    </Form.Group>

                                    <Form.Group className="mb-4">

                                        <Form.Label>
                                            Transaction ID
                                        </Form.Label>

                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Transaction ID"
                                            className="fund-input"
                                        />

                                    </Form.Group>

                                    <Button className="request-btn">

                                        <i className="bi bi-send-fill"></i>

                                        Request Fund

                                    </Button>

                                </Form>

                            </Col>

                        </Row>

                    </Card>



                    <Card className="history-card">

                        <div className="history-header">

                            <div>

                                <h4>
                                    Fund Request Details
                                </h4>

                                <p>
                                    Recent submitted payment requests
                                </p>

                            </div>

                        </div>

                        <div className="table-responsive">

                            <Table hover className="history-table align-middle">

                                <thead>

                                    <tr>

                                        <th>S.NO</th>
                                        <th>USER ID</th>
                                        <th>AMOUNT</th>
                                        <th>TXN ID</th>
                                        <th>DATE</th>
                                        <th>STATUS</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {requestHistory.map((item) => (

                                        <tr key={item.id}>

                                            <td>{item.id}</td>

                                            <td>
                                                <div className="user-box">

                                                    <div className="user-icon">

                                                        <i className="bi bi-person-fill"></i>

                                                    </div>

                                                    {item.userId}

                                                </div>
                                            </td>

                                            <td>{item.amount}</td>

                                            <td>{item.txn}</td>

                                            <td>{item.date}</td>

                                            <td>

                                                <Badge
                                                    className={`status-badge ${item.status.toLowerCase()}`}
                                                >
                                                    {item.status}
                                                </Badge>

                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </Table>

                        </div>

                    </Card>

                </Container>

            </div>
        </>
    );
};

